import { Navigate, Routes as ReactRoutes, Route } from "react-router-dom";
import NotFound from "views/NotFound/NotFound";
import Schedule from "views/Schedule/Schedule";
import TeacherList from "views/Teacher/TeacherList";
import Usefull from "views/Usefull/Usefull";
import Home from "./views/Home";

const Routes = () => {
  return (
    <ReactRoutes>
      <Route key="home" path="/" element={<Home />} />
      <Route key="schedule" path="/schedule" element={<Schedule />} />
      <Route key="teachers" path="/teachers" element={<TeacherList />} />
      <Route key="usefull" path="/usefull" element={<Usefull />} />
      {/* <Route key="pictures" path="/Pictures" element={<Pictures />} /> */}
      <Route key="notfound" path="/not-found" element={<NotFound />} />
      <Route path="*" element={<Navigate replace to="/not-found" />} />
    </ReactRoutes>
  );
};

export default Routes;
